// saveWelcomeBackData.js
'use strict';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import { AuthId } from '../resource/loginRegisterConstants.js';
import { SET_OPERATION_DATA, PERSIST_NOW } from '../ActionTypes.js';

const SUPPORTED_AUTH_METHODS = [
  AuthId.PASSWORD,
  AuthId.EMAIL,
  AuthId.PHONE_NUMBER,
  AuthId.GOOGLE,
  AuthId.APPLE,
  AuthId.APPLE_ID_NEW,
  AuthId.WEB_AUTHN,
];

/**
 * Save welcome back data
 * @kind action
 * @return {Promise} Action promise.
 */
const saveWelcomeBackData = () => (dispatch, getState) => {
  const state = getState();
  const userId = getMeData(state, 'id');
  const username = getMeData(state, 'username');
  const authMethod = getOperationData(state, ['login'], 'authMethod');

  if (!userId || !username || !SUPPORTED_AUTH_METHODS.includes(authMethod)) {
    return dispatch({ type: '' });
  }

  const data = {
    userId,
    username,
    authMethod,
    lastLoginAt: Date.now(),
  };

  if (authMethod === AuthId.PHONE_NUMBER) {
    data.phoneCountryCode = getOperationData(
      state,
      ['login'],
      'phoneCountryCode'
    );
    data.phoneNumber = getOperationData(state, ['login'], 'phoneNumber');
    data.e164PhoneNumber = getOperationData(
      state,
      ['login'],
      'e164PhoneNumber'
    );
  }

  if (authMethod === AuthId.EMAIL) {
    data.email = getOperationData(state, ['login'], 'email');
  }

  dispatch({
    type: SET_OPERATION_DATA,
    payload: { selectPath: ['welcomeBack'], data },
  });
  return dispatch({ type: PERSIST_NOW });
};

export default saveWelcomeBackData;
